import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group'

import { cn, isFieldInvalid } from '@/utils'

import { useFieldContext } from './form'

export type RadioButtonProps = {
  danger?: boolean
  disabled?: boolean
  label?: string
  labelClassName?: string
  radioClassName?: string
  value: string
  wrapperClassName?: string
} & React.ComponentProps<typeof RadioGroupItem>

export const RadioButton = ({
  danger,
  label,
  radioClassName = '',
  value,
  wrapperClassName = '',
  ...props
}: RadioButtonProps) => {
  const field = useFieldContext<string | undefined>()
  const isInvalid = isFieldInvalid(field)

  return (
    <div className={cn('flex items-center gap-3', wrapperClassName)}>
      <RadioGroup
        className="grid gap-2"
        data-invalid={isInvalid || undefined}
        onValueChange={(val) => field.handleChange(val)}
        value={field.state.value}
      >
        <div className="flex items-center gap-2">
          <RadioGroupItem
            aria-invalid={isInvalid || undefined}
            className={cn(
              radioClassName,
              danger && 'data-[state=checked]:bg-primary'
            )}
            id={`${field.name}-${value}`}
            value={value}
            {...props}
          />
          {label && (
            <label
              className={cn('text-sm', props.labelClassName)}
              htmlFor={`${field.name}-${value}`}
            >
              {label}
            </label>
          )}
        </div>
      </RadioGroup>
    </div>
  )
}
